
import {Grid, Typography} from "@mui/material";
import Lista_Proyectos from "./Componentes/SubComponentes/Lista_Proyectos";
import Tarjeta_Trabajador_Nosotros from "./Tarjetas/Tarjeta_Trabajador_Nosotros";
import diego from '../../Recursos/diego.png'
import luis from '../../Recursos/luis.png'
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const trabajadores = [
    {
        icono: diego,
        nombre: "Diego Polo",
        cargo: "Desarrollador web",
        descripcion:
            "Desarrollo web, experiencia de usuario y aprendiz de por vida.",
    },
    // {
    //     icono: luis,
    //     nombre: "Luiz Paz Caicedo",
    //     cargo: "Sofware developer",
    //     descripcion:
    //         "Apasionado de los videojuegos y el anime",
    // },

];

const Seccion_Nosotros = () => {

    const { sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}} sx={{background: '#F1F5F8',   height: '100vh'}}>
            <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{ pt: sCell ? 8 : 8}}>


                <Grid container justifyContent={'center'} spacing={3} size={{xs: 12, sm: 12, md: 12}}
                //      sx={{pt:sCell?2:2}}
                >
                    {trabajadores.map((trabajador, index) => (
                        <Grid container justifyContent={'center'}  size={{xs: 12, sm: 12, md: 12}} key={index}>
                            <Tarjeta_Trabajador_Nosotros
                                icono={trabajador.icono}
                                nombre={trabajador.nombre}
                                cargo={trabajador.cargo}
                                descripcion={trabajador.descripcion}
                            />
                        </Grid>
                    ))}
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Nosotros